import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const ComingSoon = ({ toggle, setToggle }) => {
    const navigate = useNavigate();

    // Function to handle the back button click
    const handleBack = () => {
        navigate(-1);
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-br bg-light dark:bg-dark px-4 relative">
            {/* Glowing circle effect */}
            <div className="absolute top-1/4 left-1/3 w-72 h-72 rounded-full bg-purple-300 blur-3xl opacity-20 animate-pulse"></div>
            <div className="absolute bottom-1/4 right-1/4 w-72 h-72 rounded-full bg-blue-300 blur-3xl opacity-20 animate-pulse"></div>

            <div className="text-center max-w-lg bg-white/20 backdrop-blur-md p-6 rounded-lg shadow-2xl border border-white/30 relative z-10">
                <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 mb-4 animate-bounce">
                    Coming Soon!
                </h1>
                <p className="text-base sm:text-lg md:text-xl text-dark dark:text-light max-w-md mx-auto mb-6">
                    We are working hard to launch this feature. Stay tuned for updates!
                </p>
                <div className="mt-6">
                    <motion.button
                        onClick={() => window.location.href = "mailto:kailashjobmail007@gmail.com"}
                        className="px-6 py-3 text-lg bg-gradient-to-r from-purple-500 to-red-500 text-white font-semibold rounded-lg shadow-lg hover:scale-105 transition-transform duration-200"
                    >
                        Notify Me
                    </motion.button>
                </div>

                {/* Back Button */}
                <div className="mt-4">
                    <button
                        onClick={handleBack}
                        className="px-4 py-2 text-base bg-white/20 backdrop-blur-md text-dark dark:text-light rounded-lg shadow-lg hover:bg-gray-500 hover:text-white transition ease-in-out duration-300 border-2 border-dark dark:border-light"
                    >
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ComingSoon;
